import { render, staticRenderFns } from "./NewRirekishoEdit.vue?vue&type=template&id=76852776&scoped=true"
import script from "./NewRirekishoEdit.vue?vue&type=script&lang=js"
export * from "./NewRirekishoEdit.vue?vue&type=script&lang=js"
import style0 from "./NewRirekishoEdit.vue?vue&type=style&index=0&id=76852776&prod&lang=scss&scoped=true"
import style1 from "./NewRirekishoEdit.vue?vue&type=style&index=1&id=76852776&prod&scoped=true&lang=css"
import style2 from "./NewRirekishoEdit.vue?vue&type=style&index=2&id=76852776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76852776",
  null
  
)

export default component.exports